import cognitoAuth from "@/cognito";

export default (to, from, next) => {
  cognitoAuth.isAuthenticated((res, loggedIn) => {
    if (loggedIn) {
      return next();
    } else if (!loggedIn) {
      next("/login");
    }
  });
};
